import { Component, h, Prop, Element } from '@stencil/core';

@Component({
  tag: 'dc-ui-anchor-bar-item',
  styleUrl: 'dc-ui-anchor-bar-item.scss',
  shadow: true,
})
export class DcUiAnchorBarItem {
  @Element() el: HTMLElement;
  @Prop({ reflect: true }) href: string;
  @Prop() label: string;
  @Prop() selected: boolean = false;
  @Prop() disabled: boolean = false;

  render() {
    return (
      <a
        class={{
          'dc-ui-anchor-bar-item': true,
          'dc-ui-anchor-bar-item--selected': this.selected,
          'dc-ui-anchor-bar-item--disabled': this.disabled,
        }}
        href={this.href}>
        <dc-ui-text weight="inherit">{this.label}</dc-ui-text>
        <dc-ui-text
          aria-hidden="true"
          weight="inherit"
          class="hidden-text">
          {this.label}
        </dc-ui-text>
      </a>
    );
  }
}
